import { render, staticRenderFns } from "./modalCrearEquipo.vue?vue&type=template&id=f12c610e"
import script from "./modalCrearEquipo.vue?vue&type=script&lang=js"
export * from "./modalCrearEquipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports